import { useEffect, useState } from 'react'
import { Scene } from 'three'
import { isDirectionalLight } from './utils/type-guards'
import { SceneLight } from './types/scene-light'
import { ViewerConfig } from '../../../trillion-common/src/objects/viewer-config.object'
import { createLightFromConfig } from './utils/createLightFromConfig'

export function useLights(scene: Scene, viewerConfig: ViewerConfig | undefined) {
  const [lights, setLights] = useState<SceneLight[] | undefined>()

  useEffect(() => {
    if (!viewerConfig) return
    if (!viewerConfig.lights) throw new Error('Viewer config must have lights')
    setLights(viewerConfig.lights.map(createLightFromConfig))
  }, [viewerConfig])

  useEffect(() => {
    if (!lights) return
    lights.forEach((light) => addLightToScene(light, scene))
    return () => {
      lights.forEach((light) => removeLightFromScene(light, scene))
    }
  }, [scene, lights])

  return lights
}

function addLightToScene(light: SceneLight, scene: Scene) {
  scene.add(light)
  if (isDirectionalLight(light)) {
    scene.add(light.target)
  }
}

function removeLightFromScene(light: SceneLight, scene: Scene) {
  scene.remove(light)
  if (isDirectionalLight(light)) {
    scene.remove(light.target)
  }
}
